import React from 'react';
import { DatoCmsLink } from '../../schema/datocms/blocks';
import { getButtonClass } from '../../utilities';
import Link from '../link/link';
import HtmlEntityTextComponent from '../html-entity-text/html-entity-text-component';

const Button = ({ displayText, internalPageReference, externalPageUrl, internalSectionComponentId, styleOverride, additionalOnClickActions, ...rest }: React.PropsWithChildren<DatoCmsLink> & React.HTMLAttributes<Element>): React.ReactElement => {
    let btnClass: string = getButtonClass(styleOverride);
    if (rest && rest.className) {
        btnClass = `${btnClass} ${rest.className}`;
    }
    const displayTextContent = displayText ? displayText : '';
    return (
        <Link
            internalPageReference={internalPageReference}
            internalPageSectionId={internalSectionComponentId}
            externalPageUrl={externalPageUrl}
            className={btnClass}
            additionalOnClickActions={additionalOnClickActions}>
            { <HtmlEntityTextComponent text={displayTextContent} /> }
        </Link>
    );
};

export default Button;
